module.exports = __webpack_public_path__ + "img/16.eee2a107.png";